import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import React from 'react';
import { ModeFunIcon, ModeNormalIcon, ModeSpicyIcon, TOOLTIP_CLASSES } from './ControlIcons';

interface ModeSelectorProps {
  model: string;
  mode: string;
  activeDropdown: string | null;
  toggleDropdown: (name: string) => void;
  handleSelect: (type: string, val: string, label: string) => void;
  highlighted: boolean;
}

export function ModeSelector({
  model,
  mode,
  activeDropdown,
  toggleDropdown,
  handleSelect,
  highlighted,
}: ModeSelectorProps) {
  if (model !== 'grok-imagine') return null;

  const ModeButtonIcon = () => {
    if (mode === 'normal') return <ModeNormalIcon />;
    if (mode === 'fun') return <ModeFunIcon />;
    if (mode === 'spicy') return <ModeSpicyIcon />;
    return <ModeNormalIcon />;
  };

  return (
    <div className="control-group">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className={cn('custom-select', highlighted && 'pulse-highlight')}
            onClick={() => toggleDropdown('mode')}
            aria-label="Mode"
          >
            <span className="select-icon">
              <ModeButtonIcon />
            </span>
            <span className="select-arrow">
              <ChevronDown
                className={`h-3 w-3 transition-transform ${activeDropdown === 'mode' ? 'rotate-180' : ''}`}
              />
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent className={TOOLTIP_CLASSES} sideOffset={8} showArrow={false}>
          <div>
            <span className="capitalize">{mode}</span> Mode
          </div>
        </TooltipContent>
      </Tooltip>
      {activeDropdown === 'mode' && (
        <div className="select-options active z-[100]">
          {[
            { m: 'normal', Icon: ModeNormalIcon },
            { m: 'fun', Icon: ModeFunIcon },
            { m: 'spicy', Icon: ModeSpicyIcon },
          ].map(({ m, Icon }) => (
            <button
              key={m}
              type="button"
              className={cn('option w-full text-left capitalize', mode === m && 'selected')}
              onClick={() => handleSelect('mode', m, m.charAt(0).toUpperCase() + m.slice(1))}
            >
              <Icon size={24} />
              {m.charAt(0).toUpperCase() + m.slice(1)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
